<template>
  <div id="app" class="module">
    <router-view @onShowLogin="showLogin"/>
    <a-modal
      title="登录"
      :visible="showLoginModal"
      @cancel="showLoginModal = false"
      :closable="true"
      :maskClosable="true"
      class="serviceGuideModal"
      :footer="null"
      :centered="true"
    >
      <div class="login_panel" v-if="!$store.state.isMobile">
        <a-row class="login_panel_title">登录您的喵呜AI</a-row>
        <a-row class="login_panel_input">
          <a-input class="input_login_custom" ref="userNameInput" v-model="phone" placeholder="请输入您的手机号">
            <a-icon slot="prefix" type="tablet" />
          </a-input>
        </a-row>
        <a-row class="login_panel_input">
          <a-input class="input_login_custom" ref="userNameInput" v-model="password"  type="password" placeholder="请输入您的密码">
            <a-icon slot="prefix" type="lock"/>
          </a-input>
        </a-row>
        <a-row class="login_panel_tips">请使用您的喵呜账号登录，若您还没有<span class="color_green" @click=jumpCooperate>注册喵呜账号</span>
          ，请联系商务获取注册码后下载app注册登录</a-row>
        <a-row class="login_panel_btn">
          <a-button type="primary" class="btn_now" @click="login">
            登录
          </a-button>
        </a-row>
      </div>
      <div class="login_panel_mobile" v-else>
        <a-row class="login_panel_title">登录您的喵呜AI</a-row>
        <a-row class="login_panel_input">
          <a-input class="input_login_custom" ref="userNameInput" v-model="phone" placeholder="请输入您的手机号">
            <a-icon slot="prefix" type="tablet" />
          </a-input>
        </a-row>
        <a-row class="login_panel_input">
          <a-input class="input_login_custom" ref="userNameInput" v-model="password"  type="password" placeholder="请输入您的密码">
            <a-icon slot="prefix" type="lock"/>
          </a-input>
        </a-row>
        <a-row class="login_panel_tips">请使用您的喵呜账号登录，若您还没有<span class="color_green" @click=jumpCooperate>注册喵呜账号</span>
          ，请联系商务获取注册码后下载app注册登录</a-row>
        <a-row class="login_panel_btn">
          <a-button type="primary" class="btn_now" @click="login">
            登录
          </a-button>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMeta from 'vue-meta'
import CryptoJS from 'crypto-js'
Vue.use(VueMeta)

export default {
  name: 'App',
  /* metaInfo: {
    link: [
      {
        rel: 'icon',
        href: '/favicon.ico'
      }
    ]
  }, */
  provide () {
    return {
      showLogin: this.showLogin
    }
  },
  data () {
    return {
      showLoginModal: false,
      phone: '',
      password: '',
      isMobile: false
    }
  },
  created () {
    this.checkDevice()
  },
  mounted () {
    /* const aesKey = 'm1i2a3o4w5u61020'
    const aesIv = '2023102117451234'
    const paramsJson = {
      'identity': '19968160979',
      'password': 'lh@123456'
    }
    const paramsJsonStr = JSON.stringify(paramsJson)
    // 加密
    let encryptContent = this.encrypt(paramsJsonStr, aesKey, aesIv)
    console.log('encryptContent:', encryptContent)
    let jiemi = this.decrypt(encryptContent, aesKey, aesIv)
    console.log('jiemi', jiemi) */
  },
  methods: {
    checkDevice () {
      const userAgent = navigator.userAgent.toLowerCase()
      const mobileKeywords = ['iphone', 'android', 'windows phone']
      this.isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword))
      console.log('isMobile', this.isMobile)
      this.$store.commit('updateMobile', this.isMobile)
    },
    showLogin () {
      console.log('enter showLogin')
      this.showLoginModal = true
    },
    isNumeric (str) {
      return /^\d+$/.test(str)
    },
    encrypt (content, key, iv) {
      return CryptoJS.AES.encrypt(content, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).ciphertext.toString()
    },
    // 解密方法
    decrypt (content, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key)
      let iv2 = CryptoJS.enc.Utf8.parse(iv)
      let result = CryptoJS.AES.decrypt(content, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      let result2 = result.toString(CryptoJS.enc.Utf8)
      return result2
    },
    encryptData (data, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key) // 16位iv
      let iv2 = CryptoJS.enc.Utf8.parse(iv) // 16位iv
      let encrypted = CryptoJS.AES.encrypt(data, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString()
    },

    decryptData (data, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key)
      let iv2 = CryptoJS.enc.Utf8.parse(iv) // 16位iv
      let decrypted = CryptoJS.AES.decrypt(data, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return decrypted.toString(CryptoJS.enc.Utf8)
    },
    login () {
      // 消除字符串的首尾空格。
      this.phone = this.phone.trim()
      this.password = this.password.trim()
      // 判断用户名 密码 是否为空
      if (this.phone === '') {
        this.$message.error('手机号不能为空')
        return
      }
      if (this.password === '') {
        this.$message.error('密码不能为空')
        return
      }
      if (!this.isNumeric(this.phone)) {
        this.$message.error('手机号格式不符合要求')
        return
      }
      if (!this.validPassword(this.password)) {
        this.$message.error('密码格式不符合要求')
        return
      }
      // 请求密钥
      this.$api.getAesKey().then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData && typeof resData !== 'undefined') {
            let keyData = resData.key_data
            let keyStr = resData.key_str
            // 解密API
            let jieApiContent = this.decryptData(keyData, keyStr, keyStr)
            let jieApiContentjson = JSON.parse(jieApiContent)
            let aesKey = jieApiContentjson.aes_key
            let aesIv = jieApiContentjson.aes_iv

            const paramsJson = {
              'identity': this.phone,
              'password': this.password,
              'login_type': 'h5'
            }
            const paramsJsonStr = JSON.stringify(paramsJson)
            // 加密
            let encryptContent = this.encryptData(paramsJsonStr, aesKey, aesIv)
            // console.log('encryptContent', encryptContent)

            let newJsonParams = {
              data: encryptContent
            }
            // 登录方法
            this.$api.login(newJsonParams).then(res => {
              if (res && res.status === 200) {
                const responseData = res.data
                if (responseData.status === 'ok') {
                  this.$message.success('登录成功')
                  const token = 'Bearer ' + responseData.data.access_token
                  let userAuth = {}
                  userAuth.username = this.phone
                  userAuth.accessToken = responseData.data.access_token
                  userAuth.password = ''
                  userAuth.userToken = token
                  userAuth.haveLogin = true
                  this.$store.commit('updateUserAuth', userAuth)
                  this.$store.commit('updateShowPanel', false)
                  this.showLoginModal = false

                  this.$api.getUserInfo().then(res => {
                    if (res && res.status === 200) {
                      const resData = res.data.data
                      if (resData && typeof resData !== 'undefined') {
                        let userInfo = {}
                        if (resData.length > 0) {
                          userInfo = resData[0]
                        }
                        this.$store.commit('updateUserInfo', userInfo)
                      }
                    } else {
                      this.$message.error('用户信息获取失败' + res.status)
                    }
                  }).catch(error => {
                    console.log('当前用户信息获取失败:', error)
                    this.$message.error('当前用户信息获取失败')
                  })

                  // 请求项目列表
                  this.$api.projectList(this.phone, token).then(res => {
                    if (res && res.status === 200) {
                      const resData = res.data.data
                      if (resData && typeof resData !== 'undefined') {
                        if (resData.length === 0) {
                          setTimeout(() => {
                            this.$message.error('用户尚未创建项目')
                          }, 2000)
                        } else {
                          this.$store.commit('updateProject0', resData[0])
                        }
                      }
                    } else {
                      setTimeout(() => {
                        this.$message.error('用户项目获取失败')
                      }, 2000)
                    }
                  }).catch(error => {
                    console.log('当前用户项目获取失败:', error)
                    this.$message.error('当前用户项目获取失败')
                  })
                }
              }
              /* else {
                console.log('登录失败l ', res.)
              } */
            }).catch(error => {
              console.log('登录失败:', error)
              if (error.data.msg === '邮箱格式不正确') {
                this.$message.error('登录失败登录账号错误')
              } else {
                this.$message.error('登录失败' + error.data.msg)
              }
            })
          }
        } else {
          console.log('aes data fail:', res)
        }
      }).catch(error => {
        console.log('aes data error:', error)
      })
    },
    jumpCooperate () {
      this.showLoginModal = false
      this.$router.push({ path: '/help', query: { contact: 2 } })
    },
    validPassword (testString) {
      const regex = new RegExp(/^(?=.*[a-zA-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.*\d)[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]{8,20}$/)
      if (regex.test(testString)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less">
#app {
  //font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: PingFang SC, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
  user-select: none;
  background-image: url("assets/module.jpg");
  background-size: cover;
}
img[lazy="loading"] {
  width: 106px;
  height: 98px;
}
.module{
  width: 100vw;
  min-height: 100vh;
  display: block;
  /*background-image: url("assets/module.jpg");
  background-size: cover;*/
}
@media (max-width: 450px) {
  .module{
    height: auto;
    background-size: auto;
  }
}
.txt_align_left{
  text-align: left;
}
body{
  margin: 0;
}
.div_left{
  float: left;
}
.color_green{
  color: #28E04A
}
.login_panel_btn{
  display: flex;
  text-align: center;
  justify-content: center;
}
.login_panel{
  height: 482px;
  background: #FFFFFF;
  border-radius: 12px;
  opacity: 1;
  padding: 60px 65px 0 62px;
  .login_panel_title{
    font-size: 36px;
    font-weight: 500;
    color: rgba(0,0,0,0.75);
    line-height: 42px;
    margin-bottom: 40px;
  }
  .login_panel_input{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    margin-bottom: 24px;
    .input_login_custom{
      width: 398px;
      height: 62px;
      border-radius: 10px 10px 10px 10px;
      .ant-input{
        height: 62px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
      }
    }
  }
  .login_panel_tips{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 32px;
  }
  .btn_now{
    width: 166px !important;
    height: 54px !important;
    background: #28E04A !important;
    border-radius: 8px 8px 8px 8px;
    border-color: #28E04A !important;
    opacity: 1;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #000c17 !important;
  }
  .btn_now:hover{
    background: rgb(60, 244, 94) !important;
    color: #000c17 !important;
  }
}

.login_panel_mobile{
  height: 482px;
  background: #FFFFFF;
  border-radius: 12px;
  opacity: 1;
  padding: 10px 0 0 0;
  .login_panel_title{
    font-size: 36px;
    font-weight: 500;
    color: rgba(0,0,0,0.75);
    line-height: 42px;
    margin-bottom: 40px;
  }
  .login_panel_input{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    margin-bottom: 24px;
    .input_login_custom{
      height: 62px;
      border-radius: 10px 10px 10px 10px;
      .ant-input{
        height: 62px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
      }
    }
  }
  .login_panel_tips{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 32px;
  }
  .btn_now{
    width: 166px !important;
    height: 54px !important;
    background: #28E04A !important;
    border-radius: 8px 8px 8px 8px;
    border-color: #28E04A !important;
    opacity: 1;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #000c17 !important;
  }
  .btn_now:hover{
    background: rgb(60, 244, 94) !important;
    color: #000c17 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue